import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../../../services/user-services/user.service';
import {GlobalConstantsComponent} from '../../../../shared/global-constants/global-constants.component';
import {DocumentsService} from '../../../../services/user-services/documents.service';
import {TranslateModule} from '@ngx-translate/core';
import {FaqAccordionComponent} from '../../../../components/faq-accordion/faq-accordion.component';
import {NgClass, NgIf} from '@angular/common';
import {HelperService} from "../../../../services/helper.service";
import { LocalSettingsService } from 'src/app/services/local-settings.service';

@Component({
  selector: 'app-hc-component-post-payment',
  templateUrl: './hc-component-post-payment.component.html',
  styleUrls: ['./hc-component-post-payment.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, FaqAccordionComponent, TranslateModule]
})
export class HcComponentPostPaymentComponent implements OnInit {
  @Output() private isEditTriggered: EventEmitter<string> = new EventEmitter<string>();
  public isMobile = false;
  public pdfLoading = false;
  public fileURL;
  private rawMediaURL: string = GlobalConstantsComponent.rawMediaURL
  private pdfItem: any;
  private payout: any;

  faqFields = [
    {
      key: "FAQS.ACCOMMODATION.CAT.ATTEST_ACCOM.FIRST_TITLE",
      content: [
        {
          key: "FAQS.ACCOMMODATION.CAT.ATTEST_ACCOM.FIRST_ANSWER",
        },
      ]
    },
    {
      key: "FAQS.ACCOMMODATION.CAT.ATTEST_ACCOM.SECOND_TITLE",
      content: [
        {
          key: "FAQS.ACCOMMODATION.CAT.ATTEST_ACCOM.SECOND_ANSWER",
        },
      ]
    },
    {
      key: "FAQS.ACCOMMODATION.CAT.ATTEST_ACCOM.THIRD_TITLE",
      content: [
        {
          key: "FAQS.ACCOMMODATION.CAT.ATTEST_ACCOM.THIRD_ANSWER",
        },
      ]
    },
    {
      key: "FAQS.ACCOMMODATION.CAT.ATTEST_ACCOM.FOURTH_TITLE",
      content: [
        {
          key: "FAQS.ACCOMMODATION.CAT.ATTEST_ACCOM.FOURTH_ANSWER",
        },
      ]
    },

  ];
  currentLanguage: string;


  constructor(
    private userService: UserService,
    private router: Router,
    private userDocumentService: DocumentsService,
    private helperService: HelperService,
    private localSettings: LocalSettingsService,

  ) { }

  ngOnInit(): void {

    this.localSettings.language$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );

    this.isMobile = this.userService.isMobileUser;
    this.pdfLoading = true;

    this.userService.getPayout('housing-certificate').subscribe(data => {
      if(data && data.transaction_id && data.transaction_id != 'ch_none'){
        this.payout = data;
        this.userDocumentService.getDocuments('ATT_LGT').subscribe(data => {
          const document = data.documents[ data.documents.length -1];
          this.fileURL = this.rawMediaURL + document.pivot.path + document.pivot.filename;
          this.pdfItem = data.doc;
          this.pdfLoading = false;
        });

        let hubspotDatas = {
          campagne: '',
          source: '',
          medium: '',
          item_type: 'Payout',
          item_id: this.payout.id
        };
        hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
        this.userService.setHubspotDeal(6459040, 19276180, hubspotDatas).subscribe();
      }
      else{
        this.router.navigate([this.currentLanguage +'/housing-certificate/start']);
      }
    });

  }

  download() {
    window.open(this.pdfItem);
  }

  public goToForm(){
    window.open('https://form.typeform.com/to/nBqofqIm');
  }

}
